import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

// Tabs
import StaffPaperEditDayInterruptions from './StaffPaperEditDayInterruptions';
import getLocale from '../../../i18n/getLocale';

class StaffPaperEditDay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      aircraft_model_id: null,
      date: null,
      modal: false,
      modal_interruptions: false,
      schedule_initials_select: [],
      aircraft_models_select: [],
      staff_paper_day_aircraft_models: [],
      staff_paper_day_interruptions: [],
      id: this.props.day.id,
      schedule_initial_id: this.props.day.schedule_initial_id,
      departure_location: this.props.day.departure_location,
      arrival_location: this.props.day.arrival_location,
      add_interruption_start: this.props.day.start_str,
      start: this.props.day.start,
      interruption_start: this.props.day.interruption_start,
      interruption_finish: this.props.day.interruption_finish,
      second_interruption_start: this.props.day.second_interruption_start,
      second_interruption_finish: this.props.day.second_interruption_finish,
      add_interruption_finish: this.props.day.finish_str,
      total_time: this.props.day.total_time,
      night_time: this.props.day.night_time,
      flight_time: this.props.day.flight_time,
      updated: 0,
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.deleteAircraftModel = this.deleteAircraftModel.bind(this);
    this.addAircraftModel = this.addAircraftModel.bind(this);
    this.editInterruptions = this.editInterruptions.bind(this);
    this.addInterruptions = this.addInterruptions.bind(this);
    this.deleteInterruptions = this.deleteInterruptions.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.autoUpdate = this.autoUpdate.bind(this);

    this.locale = getLocale();
  }
  
  // Handlers
  handleChangeDate (name, event) {
    if(!event.target.value) {
      var change = {};
      change[name] = this.state.date;
      this.setState(change);

    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 || newProps.updated == true) && typeof newProps.day.date !== 'undefined' && Array.isArray(newProps.schedule_initials_select) && Array.isArray(newProps.aircraft_models_select)) {
      this.setState({
        id: newProps.day.id,
        staff_paper_day_aircraft_models: newProps.day.staff_paper_day_aircraft_models,
        staff_paper_day_interruptions: newProps.day.staff_paper_day_interruptions,
        schedule_initial_id: newProps.day.schedule_initial_id,
        departure_location: newProps.day.departure_location,
        arrival_location: newProps.day.arrival_location,


        
        start_date: newProps.day.start_date,
        start_hour: newProps.day.start_hour,
        interruption_start_date: newProps.day.interruption_start_date,
        interruption_start_hour: newProps.day.interruption_start_hour,
        interruption_finish_date: newProps.day.interruption_finish_date,
        interruption_finish_hour: newProps.day.interruption_finish_hour,
        second_interruption_start_date: newProps.day.second_interruption_start_date,
        second_interruption_start_hour: newProps.day.second_interruption_start_hour,
        second_interruption_finish_date: newProps.day.second_interruption_finish_date,
        second_interruption_finish_hour: newProps.day.second_interruption_finish_hour,
        finish_date: newProps.day.finish_date,
        finish_hour: newProps.day.finish_hour,
        
        start: newProps.day.start_str,
        interruption_start: newProps.day.interruption_start_str,
        interruption_finish: newProps.day.interruption_finish_str,
        second_interruption_start: newProps.day.second_interruption_start_str,
        second_interruption_finish: newProps.day.second_interruption_finish_str,
        finish: newProps.day.finish_str,
        total_time: newProps.day.total_time,
        night_time: newProps.day.night_time,
        flight_time: newProps.day.flight_time,
        interruption_time: newProps.day.interruption_time,
        date: newProps.day.date_str,
        schedule_initials_select: newProps.schedule_initials_select,
        aircraft_models_select: newProps.aircraft_models_select,
        loaded: 1,
      });
    }
    if(newProps.updated == true) {
      this.props.changeUpdate();
      
    }
  }

  // Fetch salvando a edição
  edit() {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      schedule_initial_id: this.state.schedule_initial_id,
      departure_location: this.state.departure_location,
      arrival_location: this.state.arrival_location,
      start_date: this.state.start_date,
      start_hour: this.state.start_hour,
      interruption_start_date: this.state.interruption_start_date,
      interruption_start_hour: this.state.interruption_start_hour,
      interruption_finish_date: this.state.interruption_finish_date,
      interruption_finish_hour: this.state.interruption_finish_hour,
      second_interruption_start_date: this.state.second_interruption_start_date,
      second_interruption_start_hour: this.state.second_interruption_start_hour,
      second_interruption_finish_date: this.state.second_interruption_finish_date,
      second_interruption_finish_hour: this.state.second_interruption_finish_hour,
      finish_date: this.state.finish_date,
      finish_hour: this.state.finish_hour,
      total_time: this.state.total_time,
      night_time: this.state.night_time,
      flight_time: this.state.flight_time,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/dia/' + self.state.id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        self.setState({total_time: responseJson.data.total_time_str});
        self.setState({night_time: responseJson.data.night_time});
        self.setState({flight_time: responseJson.data.flight_time});
        self.setState({interruption_time: responseJson.data.interruption_time});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addAircraftModel(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_paper_day_id: this.state.id,
      aircraft_model_id: this.state.aircraft_model_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        self.setState({staff_paper_day_aircraft_models: responseJson.data});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteAircraftModel(id) {
    if(window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.DeletarFrota)) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/frota/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          self.setState({staff_paper_day_aircraft_models: responseJson.data});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  addInterruptions(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_paper_day_id: this.state.id,
      start: this.state.add_interruption_start,
      finish: this.state.add_interruption_finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/interrupcao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status == 'success') {
          self.setState({staff_paper_day_interruptions: responseJson.data.staff_paper_day_interruptions});
          self.setState({total_time: responseJson.data.staff_paper_day.total_time_str});
          self.setState({night_time: responseJson.data.staff_paper_day.night_time});
          self.setState({flight_time: responseJson.data.staff_paper_day.flight_time});
          self.setState({interruption_time: responseJson.data.staff_paper_day.interruption_time});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  editInterruptions(datasave) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/interrupcao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status == 'success') {
          self.setState({staff_paper_day_interruptions: responseJson.data.staff_paper_day_interruptions});
          self.setState({total_time: responseJson.data.staff_paper_day.total_time_str});
          self.setState({night_time: responseJson.data.staff_paper_day.night_time});
          self.setState({flight_time: responseJson.data.staff_paper_day.flight_time});
          self.setState({interruption_time: responseJson.data.staff_paper_day.interruption_time});
          self.setState({updated: 1});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteInterruptions(id) {
    if(window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.DeletarInterrupcao)) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/interrupcao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status == 'success') {
            self.deleteRow(id);
            self.setState({staff_paper_day_interruptions: responseJson.data.staff_paper_day_interruptions});
            self.setState({total_time: responseJson.data.staff_paper_day.total_time_str});
            self.setState({night_time: responseJson.data.staff_paper_day.night_time});
            self.setState({flight_time: responseJson.data.staff_paper_day.flight_time});
            self.setState({interruption_time: responseJson.data.staff_paper_day.interruption_time});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          
          }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  
  deleteRow(id) {
    var data = this.state.staff_paper_day_interruptions;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }
  
  autoUpdate() {
    var self = this;
    if(window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.AtualizarInformacoesDestaData)) {
      
      var url = "/papeleta/dia/atualizar/";
      var header = this.refs.request_api.header('application/json');
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          }
        });
      });
    }
  }


  render() {
    var self = this;
    return (
  <tr>

    <td className="text-center">
      <RequestApi ref={'request_api'} />
      {this.state.date}
    </td>
    <td className="text-center"><input type="text" name="departure_location" className="form-control form-control" placeholder="" value={this.state.departure_location} onChange={this.handleChange.bind(this, 'departure_location')} /></td>
    <td className="text-center"><input type="text" name="arrival_location" className="form-control form-control" placeholder="" value={this.state.arrival_location} onChange={this.handleChange.bind(this, 'arrival_location')} /></td>
    <td className="text-center"><Select
          name="schedule_initial_id"
          value={this.state.schedule_initial_id}
          searchable={true}
          placeholder={this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.placeholder.SelecionarSituacao}
          onChange={this.handleSelectChange.bind(this, 'schedule_initial_id')}
          options={this.state.schedule_initials_select}
        /></td>
    <td className="text-center"><InputMask value={this.state.start_date} maskChar={null} name="start_date" mask="99/99/9999" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'start_date')} onChange={this.handleChange.bind(this, 'start_date')} placeholder={this.locale.general.diaMesAno} /></td>
    <td className="text-center"><InputMask value={this.state.start_hour} maskChar={null} name="start_hour" mask="99:99" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'start_date')} onChange={this.handleChange.bind(this, 'start_hour')} placeholder={this.locale.general.horaMinuto} /></td>

    <td className="text-center"><InputMask value={this.state.interruption_start_date} maskChar={null} name="interruption_start_date" mask="99/99/9999" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'interruption_start_date')} onChange={this.handleChange.bind(this, 'interruption_start_date')} placeholder={this.locale.general.diaMesAno} /></td>
    <td className="text-center"><InputMask value={this.state.interruption_start_hour} maskChar={null} name="interruption_start_hour" mask="99:99" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'interruption_start_date')} onChange={this.handleChange.bind(this, 'interruption_start_hour')} placeholder={this.locale.general.horaMinuto} /></td>

    <td className="text-center"><InputMask value={this.state.interruption_finish_date} maskChar={null} name="interruption_finish_date" mask="99/99/9999" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'interruption_finish_date')} onChange={this.handleChange.bind(this, 'interruption_finish_date')} placeholder={this.locale.general.diaMesAno} /></td>
    <td className="text-center"><InputMask value={this.state.interruption_finish_hour} maskChar={null} name="interruption_finish_hour" mask="99:99" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'interruption_finish_date')} onChange={this.handleChange.bind(this, 'interruption_finish_hour')} placeholder={this.locale.general.horaMinuto} /></td>

    <td className="text-center"><InputMask value={this.state.second_interruption_start_date} maskChar={null} name="second_interruption_start" mask="99/99/9999" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'second_interruption_start_date')} onChange={this.handleChange.bind(this, 'second_interruption_start_date')} placeholder={this.locale.general.diaMesAno} /></td>
    <td className="text-center"><InputMask value={this.state.second_interruption_start_hour} maskChar={null} name="second_interruption_start_hour" mask="99:99" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'second_interruption_start_date')} onChange={this.handleChange.bind(this, 'second_interruption_start_hour')} placeholder={this.locale.general.horaMinuto} /></td>

    <td className="text-center"><InputMask value={this.state.second_interruption_finish_date} maskChar={null} name="second_interruption_finish_date" mask="99/99/9999" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'second_interruption_finish_date')} onChange={this.handleChange.bind(this, 'second_interruption_finish_date')} placeholder={this.locale.general.diaMesAno} /></td>
    <td className="text-center"><InputMask value={this.state.second_interruption_finish_hour} maskChar={null} name="second_interruption_finish_hour" mask="99:99" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'second_interruption_finish_date')} onChange={this.handleChange.bind(this, 'second_interruption_finish_hour')} placeholder={this.locale.general.horaMinuto} /></td>

    <td className="text-center"><InputMask value={this.state.finish_date} maskChar={null} name="finish_date" mask="99/99/9999" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'finish_date')} onChange={this.handleChange.bind(this, 'finish_date')} placeholder={this.locale.general.diaMesAno} /></td>
    <td className="text-center"><InputMask value={this.state.finish_hour} maskChar={null} name="finish_hour" mask="99:99" className="form-control form-control" onMouseDown={this.handleChangeDate.bind(this, 'finish_date')} onChange={this.handleChange.bind(this, 'finish_hour')} placeholder={this.locale.general.horaMinuto} /></td>
    <td className="text-center">
      <div className="row">
        <div className="col-md-12">
          <InputMask value={this.state.total_time} maskChar={null} disabled name="total_time" mask="99:99" className="form-control form-control" onChange={this.handleChange.bind(this, 'total_time')} placeholder={this.locale.general.horaMinuto} />
        </div>
      </div>
      </td>
    <td className="text-center"><InputMask value={this.state.night_time} maskChar={null} disabled name="night_time" mask="99:99" className="form-control form-control" onChange={this.handleChange.bind(this, 'night_time')} placeholder={this.locale.general.horaMinuto} /></td>
    <td className="text-center"><InputMask value={this.state.flight_time} maskChar={null} disabled name="flight_time" mask="99:99" className="form-control form-control" onChange={this.handleChange.bind(this, 'flight_time')} placeholder={this.locale.general.horaMinuto} /></td>
    <td className="text-center">
      <button type="submit" onClick={() => this.edit()} className="btn btn-primary btn-sm"><i className="fa fa-fw fa-save"></i></button>
    </td>
    <td className="text-center">
      <button onClick={() => self.autoUpdate()} className="btn btn-success btn-sm"><i className="fa fa-fw fa-refresh"></i> </button>
    </td>
    <td className="text-center">
      <button type="button" onClick={()=>this.setState({ modal_interruptions: true })} className="btn btn-warning btn-sm"><i className="fa fa-clock-o"></i></button>
      <Modal show={this.state.modal_interruptions} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tituloInterrupcoes}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_interruptions: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.addInterruptions}>
              <div className="row">
                <div className="col-md-4" style={{textAlign: 'center'}}>
                  <label>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioInterrupcoes.InicioDaInterrupcao}</label>
                  <InputMask value={this.state.add_interruption_start} maskChar={null} name="add_interruption_start" mask="99/99/9999 99:99" className="form-control field-papers-main-datetime" onChange={this.handleChange.bind(this, 'add_interruption_start')} placeholder={this.locale.general.diaMesAnoHoraMinuto} />
                </div>
                <div className="col-md-4" style={{textAlign: 'center'}}>
                  <label>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioInterrupcoes.FimDaInterrupcao}</label>
                  <InputMask value={this.state.add_interruption_finish} maskChar={null} name="add_interruption_finish" mask="99/99/9999 99:99" className="form-control field-papers-main-datetime" onChange={this.handleChange.bind(this, 'add_interruption_finish')} placeholder={this.locale.general.diaMesAnoHoraMinuto} />
                </div>
                <div className="col-md-4">
                  <br></br>
                  <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioInterrupcoes.botaoAdicionarInterrupcao}</button>
                </div>
              </div>
          </form>
          <hr/>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Inicio}</th>
                  <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Fim}</th>
                  <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Total}</th>
                  <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Acoes}</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(self.state.staff_paper_day_interruptions).map(function(k) {
                  var interruption = self.state.staff_paper_day_interruptions[k];
                  return (
                    <StaffPaperEditDayInterruptions handleAlert={self.props.handleAlert} editInterruptions={self.editInterruptions} deleteInterruptions={self.deleteInterruptions} updated={self.state.updated} interruption={interruption} staff_paper_day_id={self.state.id}/>
                  );
                })}
                <tr>
                  <td colSpan={2} style={{ textAlign: 'right', fontWeight: 700  }}>Total</td>
                  <td style={{ textAlign: 'center', fontWeight: 700  }}>{self.state.interruption_time}</td>
                  <td className="text-center"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_interruptions: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </td>
    <td className="text-center">
      <button type="button" onClick={()=>this.setState({ modal: true })} className="btn btn-info btn-sm"><i className="fa fa-fw fa-plane"></i></button>       
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tituloEquipamentos}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.addAircraftModel}>
            <div className="row">
              <div className="col-md-12" style={{textAlign: 'center'}}>
                <div className="form-group">
                  <Select
                    className="form-field-name"
                    name="aircraft_model_id"
                    value={this.state.aircraft_model_id}
                    searchable={true}
                    placeholder={this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioEquipamentos.placeholder.SelecionarFrota}
                    onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                    options={this.state.aircraft_models_select}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioEquipamentos.botaoAdicionarFrota}</button>
              </div>
            </div>
          </form>
          <hr/>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaEquipamentos.Frota}</th>
                  <th className="col-md-1" style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaEquipamentos.Acoes}</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(self.state.staff_paper_day_aircraft_models).map(function(k) {
                  var spdam = self.state.staff_paper_day_aircraft_models[k];
                  return (
                    <tr>
                      <td style={{textAlign: 'center'}}>{spdam.aircraft_model.model}</td>
                      <td style={{textAlign: 'center'}}><button className="btn btn-danger" onClick={() => self.deleteAircraftModel(spdam.id)}><i className="fa fa-fw fa-trash"></i></button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </td>
  </tr>
    );
  }
}

export default StaffPaperEditDay;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/Elements/StaffPaperEditDay.js